import * as React from 'react'
import {Accordion, AccordionSummary, Typography, AccordionDetails} from '@mui/material'
import {makeOcStyles} from '@oc/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = makeOcStyles(theme => ({
    summaryRootCompact: {
        padding: 0
    },
    iconLabelCompact: {
        paddingRight: '0 !important',
        textAlign: 'center',
        width: '100%'
    },
    detailsCompact: {
        padding: 0
    },
    detailsChild: {
        width: '100%'
    },
    details: {
        padding: theme.spacing(0, 1, 1, 1)
    }
}))

interface Props {
    items: {component: React.ReactNode; header?: string; customHeader?: React.ReactNode}[]
    compact?: boolean
}

function _Accordion({items, compact}: Props) {
    const {classes, cx} = useStyles()
    const [index, setIndex] = React.useState(-1)

    const summaryClassName =
        cx({
            [classes.summaryRootCompact]: compact
        }) || undefined

    const iconLabelClassName =
        cx({
            [classes.iconLabelCompact]: compact
        }) || undefined

    const detailsClass =
        cx(classes.details, {
            [classes.detailsCompact]: compact
        }) || undefined

    return (
        <>
            {items.map(({component, header, customHeader}, i) => (
                <Accordion key={i} expanded={i === index} onChange={(_, isExpanded) => setIndex(isExpanded ? i : -1)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} classes={{root: summaryClassName}}>
                        {header && <Typography className={iconLabelClassName}>{header}</Typography>}
                        {customHeader}
                    </AccordionSummary>
                    <AccordionDetails className={detailsClass}>
                        <div className={classes.detailsChild}>{component}</div>
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    )
}

export default _Accordion
